export default {
  container: {
    position: "fixed",
    bottom: 0,
    right: 0,
  },
};
